module.exports = __webpack_public_path__ + "img/icon-close.3202d394.svg";